import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useMemo } from 'react';

import { NormalizedDossier, SerializedDossiers } from '../dossier/types';
import { QUERY_STALE_TIMES } from '../../shared/providers/react-query-provider';

import { fetchArchivedDossierOverviews, fetchDossierOverviews } from './api';

export const getDossierOverviewsQueryKey = () => ['dossier-overviews'];
export const getArchivedDossierOverviewsQueryKey = (query?: string | null) => [
    'archived-dossier-overviews',
    query,
];

export const useGetDossierOverviews = (
    options?: Omit<UseQueryOptions<SerializedDossiers, Error, NormalizedDossier>, 'queryKey'>,
) => {
    return useQuery({
        queryKey: getDossierOverviewsQueryKey(),
        queryFn: fetchDossierOverviews,
        select: (data) => data.dossier,
        staleTime: QUERY_STALE_TIMES.DOSSIER_OVERVIEW,
        ...options,
    });
};

export const useGetArchivedDossierOverviews = (
    query?: string | null,
    options?: Omit<UseQueryOptions<SerializedDossiers, Error, NormalizedDossier>, 'queryKey'>,
) => {
    return useQuery({
        queryKey: getArchivedDossierOverviewsQueryKey(query),
        queryFn: () => fetchArchivedDossierOverviews(query),
        select: (data) => data.dossier,
        ...options,
    });
};

export const useHasDossiers = () => {
    const { data: dossierOverviews } = useGetDossierOverviews();
    return useMemo(() => {
        return Object.keys(dossierOverviews || {}).length > 0;
    }, [dossierOverviews]);
};
